import { render, staticRenderFns } from "./order-add-item-by-auction.vue?vue&type=template&id=3a289bfd&scoped=true"
import script from "./order-add-item-by-auction.vue?vue&type=script&setup=true&lang=js"
export * from "./order-add-item-by-auction.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a289bfd",
  null
  
)

export default component.exports